import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface WaitingOnAdminProgressionActionsProps {
  isOutsourcingExtension: boolean
  onResumeFiling: () => unknown
}

export function WaitingOnAdminProgressionActions({
  isOutsourcingExtension,
  onResumeFiling,
}: WaitingOnAdminProgressionActionsProps) {
  return (
    <CardContent>
      <Button
        label={
          isOutsourcingExtension
            ? 'Continue on Client’s Behalf'
            : 'Resume Filing on Client’s Behalf'
        }
        variant="primary"
        size="wide-slim"
        onPress={onResumeFiling}
        testId="job-progression-resume-filing-button"
      />
    </CardContent>
  )
}
